import { useMemo } from 'react';
import { Experiments } from '~/contracts/common';

function addIdentifierToExperimentsAndFilter(
  experiments: Partial<Experiments>,
  identifier?: string
): Partial<Experiments> {
  return identifier
    ? Object.keys(experiments).reduce<Partial<Experiments>>(
        (acc, experimentName) => {
          acc[experimentName as keyof Experiments] = { identifier };

          return acc;
        },
        {}
      )
    : {};
}

type OwnArgs = {
  browserCookieId: string;
  browserCookieIdExperiments: Partial<Experiments>;
  userId: string;
  userIdExperiments: Partial<Experiments>;
};

export default function useExperimentsWithIdentifiers({
  browserCookieId,
  browserCookieIdExperiments,
  userId,
  userIdExperiments
}: OwnArgs) {
  return useMemo(
    () => ({
      ...addIdentifierToExperimentsAndFilter(
        browserCookieIdExperiments,
        browserCookieId
      ),
      ...addIdentifierToExperimentsAndFilter(userIdExperiments, userId)
    }),
    [browserCookieId, browserCookieIdExperiments, userId, userIdExperiments]
  );
}
